export function requireFiniteNonNegative(value: number, name: string): number {
  if (!Number.isFinite(value) || value < 0) throw new Error(`${name} must be a finite non-negative number`);
  return value;
}

export function requireFinitePositive(value: number, name: string): number {
  if (!Number.isFinite(value) || value <= 0) throw new Error(`${name} must be a finite positive number`);
  return value;
}

export function requirePercentage(value: number, name: string, allowZero = false): number {
  const validLowerBound = allowZero ? value >= 0 : value > 0;
  if (!Number.isFinite(value) || !validLowerBound || value > 100) {
    throw new Error(`${name} must be ${allowZero ? "between 0 and 100" : "greater than 0 and at most 100"}`);
  }
  return value;
}

export function roundTo(value: number, decimalPlaces: number): number {
  const factor = 10 ** decimalPlaces;
  return Math.round((value + Number.EPSILON) * factor) / factor;
}
